// ═══════════════════════════════════════════════════════════════════
//  modules/chat/SujCompteurs.js
//  la rangée de compteurs
//
//  Sorti de SujPanel.js le 7 aout 2026. Le JSX est celui d'origine,
//  deplace au caractere pres ; les props sont calculees par analyse
//  de portee, pas devinees.
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";
import { SUJ_CATEGORIES, SUJ_CATEGORIE_IDS } from "./constantes";
import { SujKpi } from "./SujKpi";

export function SujCompteurs({ categorie, cpt, setCategorie, statut }) {
  return (
    <>
      {/* ── 3. COMPTEURS ────────────────────────────────────────────── */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <SujKpi label={statut === "tous" ? "Sujets (tous)" : statut === "resolu" ? "Sujets résolus" : statut === "ignore" ? "Sujets ignorés" : "Sujets ouverts"}
          value={cpt ? cpt.total_sujets : "—"} color={THEME.text} active={!categorie} onClick={() => setCategorie("")} />
        {SUJ_CATEGORIE_IDS.map((id) => {
          const meta = SUJ_CATEGORIES[id];
          const v = cpt && cpt.par_categorie[id] ? cpt.par_categorie[id].n : 0;
          return <SujKpi key={id} icon={meta.icon} label={meta.label} value={v} color={meta.color}
            active={categorie === id} onClick={() => setCategorie(categorie === id ? "" : id)} />;
        })}
      </div>
    </>
  );
}
